export default "__VITE_ASSET__D6qA0XGZ__"